<template>
  <client-only>
    <div>
      <v-layout justify-center>
        <v-dialog
          v-model="dialog"
          :content-class="contentClass"
          :fullscreen="fullScreen"
          :hide-overlay="hideOverlay"
          :transition="transitionType"
          :max-width="'700px'"
        >
          <v-card class="dialog-inner">
            <v-card-title v-if="!showCVPopup" class>
              <v-flex>
                <h3 class="display-24">התחברות/הרשמה</h3>
              </v-flex>
              <v-flex class="text-left x-close">
                <v-btn color="primary large" text @click="dialog = !dialog">
                  <v-icon class="icon-forma-1-2 display-16" />
                </v-btn>
              </v-flex>

              <DropDivider :width="'100%'" />
            </v-card-title>

            <v-card-text v-if="!showCVPopup">
              <v-container grid-list-md pt-0 pl-0 pr-0>
                <v-layout wrap justify-center>
                  <v-flex text-left>
                    <v-btn
                      outlined
                      large
                      class="looking-btn display-16"
                      :class="{ 'selected-looking': showLogin }"
                      @click="
                        showLogin = !showLogin;
                        showRegister = false;
                      "
                    >
                      משתמש רשום
                    </v-btn>
                  </v-flex>

                  <v-flex text-right>
                    <v-btn
                      outlined
                      large
                      class="recruiter-btn display-16"
                      :class="{ 'selected-recruiter': showRegister }"
                      @click="
                        showRegister = !showRegister;
                        showLogin = false;
                      "
                    >
                      משתמש חדש
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout wrap justify-center>
                  <v-flex v-show="showLogin" xs12>
                    <FormLogin
                      @showCVForm="displayCVPopup"
                      :emitToCVPopup="true"
                      :activateOtpOnPage="false"
                    />
                  </v-flex>

                  <v-flex v-show="showRegister">
                    <FormSignup
                      :page="'4'"
                      @showCVForm="displayCVPopup"
                      class="pt-4"
                      :activateOtpOnPage="false"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-flex v-if="showCVPopup && isLogged && !isExternalLink">
              <CVPopup
                :AllowNoCV="AllowNoCV"
                :FullName="FullName"
                :Code="Code"
                :JobAnalytics="JobAnalytics"
                @confirmSend="handleConfirmSend"
                @closeDialog="handleCloseDialog"
                :isJobOpen="isJobOpen"
                :isAA="isAA"
                :ssasource="ssasource"
                :job-index="jobIndex"
                :IsRecommender="IsRecommender"
                :WhatFieldText="WhatFieldText"
                :currentPage="currentPage"
                :is-hitech="isHitech"
                :job-filters="jobFilters"
                :has-filters="hasFilters"
              />
            </v-flex>

            <v-flex></v-flex>
          </v-card>
        </v-dialog>
      </v-layout>
    </div>
  </client-only>
</template>

<script>
import FormSignup from '@/components/NavigationMenu/UserMenu/FormSignup';
import { mapState } from 'vuex';
import FormLogin from '@/components/NavigationMenu/UserMenu/FormLogin.vue';
import CVPopup from '@/components/Dialogs/CV_Popup/CVPopup';
import DropDivider from '@/components/DropDownMenu/DropDivider';
import CurrentUser from '@/components/mixins/CurrentUser';
import { SEND_CV_EXTERNAL } from '@/lib/api.js';

export default {
  mixins: [CurrentUser],
  scrollToTop: false,
  components: {
    FormLogin,
    CVPopup,
    DropDivider,
    FormSignup,
  },

  props: {
    jobFilters: {
      type: Array,
      required: false,
      default: () => [],
    },
    hasFilters: {
      type: Boolean,
      required: false,
      default: false,
    },
    isHitech: {
      type: Boolean,
      required: false,
      default: false,
    },
    ssasource: {
      type: Number,
      required: false,
      default: 0,
    },
    isAA: {
      type: Boolean,
      required: false,
      default: false,
    },
    openDialog: {
      type: Boolean,
      required: false,
      defalut: false,
    },
    isJobOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    ExternalLink: {
      type: String,
      required: false,
      default: '/',
    },
    FullName: {
      type: String,
      required: false,
      default: '',
    },
    Code: {
      type: Number,
      required: false,
      default: 0,
    },
    jobIndex: {
      type: Number,
      required: false,
      default: 0,
    },
    JobAnalytics: {
      type: Object,
      required: false,
    },
    jobToLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    jobCode: {
      type: [Number, Object],
      required: false,
    },
    AllowNoCV: {
      type: Boolean,
      required: true,
      default: false,
    },
    IsRecommender: {
      type: Boolean,
      required: false,
      default: false,
    },
    WhatFieldText: {
      type: String,
      required: false,
      default: '',
    },
    /** currentPage - relevant only for recommended jobs  */
    currentPage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
      showLogin: true, // temp
      showRegister: false,
      showCVPopup: false,
      user: undefined,
      fullScreen: false,
      hideOverlay: false,
      transitionType: false,
      contentClass: 'cv-dialog border-radius-20',
      dialogMaxWidth: 1000,
      timer: undefined,
    };
  },

  computed: {
    ...mapState({
      auth: (state) => state.auth,
      emailExists: (state) => state.authUser.smartAgent.firstStepCategory.email,
    }),

    isExternalLink() {
      return !!this.ExternalLink;
    },
    externalLink() {
      return this.isExternalLink ? this.ExternalLink : '';
    },
  },

  watch: {
    openDialog() {
      this.dialog = this.openDialog;
    },
  },

  created() {
    this.dialog = this.openDialog;
  },

  mounted() {
    this.dialogMobile();

    this.onLoggedIn();
  },

  updated() {
    this.onLoggedIn();
  },

  beforeDestroy() {
    this.showLogin = false;
    this.showRegister = false;
    this.user = undefined;
    this.showCVPopup = false;
    this.dialog = false;
    clearTimeout(this.timer);
  },

  methods: {
    onLoggedIn() {
      if (this.isLogged) {
        this.showCVPopup = true;
        this.user = this.CurrentUser;
        this.dialogMaxWidth = 1000;
      } else {
        this.dialogMaxWidth = 600;
      }
    },
    /**
     * @dialogMobile Adjust CV diaolg on mobile props on mounted.
     * Will display dialog on fullscreen
     */
    dialogMobile() {
      if (this.$vuetify.breakpoint.smAndDown) {
        this.fullScreen = true;
        this.hideOverlay = false;
        this.transitionType = 'dialog-bottom-transition';
        this.contentClass = '';
      }
    },

    async displayCVPopup() {
      if (this.isLogged && this.jobToLink) {
        // redirect to jobsPage-external
        try {
          await this.$axios
            .get(`${SEND_CV_EXTERNAL}?jobcode=${this.jobCode}`)
            .then((res) => {
              if (res.data.IsError) {
                throw res.data.Errors;
              }

              /** redirect to external link  
                 @param {URL} redirectTo   
              */
              let redirectTo = res.data.RedirectTo;
              const win = window.open(redirectTo);

              this.isLoading = false;
            });
        } catch (error) {
          error({ statusCode: 404, message: error });
        }
        this.dialog = false;
      } else {
        this.showLogin = false;
        this.showRegister = false;
        this.user = this.CurrentUser;
        this.showCVPopup = true;
      }
    },

    handleConfirmSend() {
      this.$nuxt.$emit('openConfirmPopup', this.isHitech, this.AllowNoCV);
      this.dialog = false;
    },

    handleCloseDialog() {
      this.$bus.$emit('closeDialog', false);
      this.dialog = false;
    },

    /**
     * method is responsible to display the login instead of register for existing user and to pass the email to thecorresponding field
     * @email { String } the users Email
     *
     */
    handleRedirectExistingUser(email) {
      this.showRegister = false;
      this.showLogin = true;
      this.$bus.$emit('existingEmailToLogin', email);
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-inner {
  max-width: 1000px;
}

.looking-btn,
.recruiter-btn {
  border-radius: 5px;
  padding: 3px 5px;
  width: 100px;
  border-color: #f6f7f9;
}

.looking-btn.selected-looking {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.recruiter-btn.selected-recruiter {
  color: $primary;
  border-color: $primary;
  pointer-events: none;
}

.looking-btn.selected-looking:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.recruiter-btn.selected-recruiter:after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 6px;
  border-style: solid;
  border-color: $primary transparent transparent transparent;
  top: 42px;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 0;
}

.password-recover {
  text-align: left;
  transform: translateY(-25px);
  color: #000;
}

@media only screen and (min-width: 600px) {
  .dialog-inner {
    padding: 16px;
  }

  .looking-btn,
  .recruiter-btn {
    border-radius: 5px;
    padding: 10px 25px;
    width: 140px;
    border-color: #f6f7f9;
  }
}
</style>
